export type Metric = {
  name: string;
  value: number;
  tags?: string[];
};
export interface User {
  id: string;
  uuid: string;
  class: "Medic" | "Patient";
}

export interface MedicUser extends User {
  class: "Medic";
  role: string;
  is_super_user?: boolean;
  first_health_centre_uuid: string;
}

export interface PatientUser extends User {
  class: "Patient";
  health_centre_id: string | number;
  health_centre_uuid: string;
}

/**
 * Checks if a given ControlTower user is a MedicUser.
 * The user will be typed as MedicUser if that is the case
 *
 * @param user ControlTower user
 */
export function isMedicUser(user: User): user is MedicUser {
  return user.class === "Medic";
}

/**
 * Checks if a given ControlTower user is a PatientUser.
 * The user will be typed as PatientUser if that is the case
 *
 * @param user ControlTower user
 */
export function isPatientUser(user: User): user is PatientUser {
  return user.class === "Patient";
}
